module.exports = __webpack_public_path__ + "media/images/firsttime_contents01_pc-b4312693b2ea790844eaf418b29de9c8.png";